import { SaveButton, Toolbar, ToolbarProps } from 'ra-ui-materialui'
import React from 'react'
import { useFormState } from 'react-hook-form'

const NoDeleteButtonToolbar: React.FC<ToolbarProps> = (props) => {
  const { isDirty } = useFormState()

  return (
    <Toolbar {...props}>
      <SaveButton disabled={!isDirty} />
    </Toolbar>
  )
}

export default NoDeleteButtonToolbar
